import { useCallback, useState } from 'react'
import { Product } from '~/types'
import {
  useAlgoliaSearchInsignts,
  useCart,
  useCartDrawer,
} from '~/hooks'
import { GTM, GTMEvent } from '~/lib'

export const useAddToCart = (product: Product) => {
  const { sku } = product

  const [quantity, setQuantity] = useState(1)

  const { addToCart } = useCart()
  const { openCartDrawer } = useCartDrawer()
  const { latestQueryId, sendAddToCartEvent, removeQueryIDFromStorage } =
    useAlgoliaSearchInsignts()

  const handleAddToCart = useCallback(() => {
    addToCart.mutate(
      [
        {
          sku,
          quantity: quantity || 1,
          algoliaQueryId: latestQueryId,
        },
      ],
      {
        onSuccess(data) {
          if (data) {
            GTM.dispatch(GTMEvent.CLEAR_ECOMMERCE)
            GTM.dispatch(GTMEvent.CART_CONTENTS_PUSH, data)
            sendAddToCartEvent(
              [sku],
              data.lineItems,
              data.subTotal,
              latestQueryId
            )
          }

          openCartDrawer()
          removeQueryIDFromStorage()
        },
      }
    )
  }, [
    addToCart,
    sku,
    quantity,
    openCartDrawer,
    removeQueryIDFromStorage,
    sendAddToCartEvent,
    latestQueryId,
  ])

  return {
    quantity,
    setQuantity,
    handleAddToCart,
    isLoading: addToCart.isLoading,
    latestQueryId,
  }
}
